import { z } from "zod";
import { activitySchema } from "../activities";

export const savedSortSchema = z.enum(["recent", "price_asc", "price_desc"]);
export type SavedSort = z.infer<typeof savedSortSchema>;

export const savedListResponseSchema = z.object({
  data: z.array(activitySchema),
  meta: z.object({
    nextCursor: z.string().nullable(),
    total: z.number().int().nonnegative(),
  }),
});
export type SavedListResponse = z.infer<typeof savedListResponseSchema>;
